import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "pb-2" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InAppLink = _resolveComponent("InAppLink")!
  const _component_Form = _resolveComponent("Form")!
  const _component_AuthLayout = _resolveComponent("AuthLayout")!

  return (_openBlock(), _createBlock(_component_AuthLayout, {
    title: _ctx.$t('Forgot Password')
  }, {
    default: _withCtx(() => [
      _createVNode(_component_Form, {
        formApi: "/forgot-password",
        hasSlotBeforeSubmitButton: true,
        fields: _ctx.fields
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createTextVNode(_toDisplayString(_ctx.$t('We will email you a password reset url ;)')), 1),
            _hoisted_2,
            _createTextVNode(" " + _toDisplayString(_ctx.$t('In case of any problems please')) + " ", 1),
            _createVNode(_component_InAppLink, { to: "/contact/error-reporting?type=resetPassword" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('click here')), 1)
              ]),
              _: 1
            }),
            _createTextVNode(". ")
          ])
        ]),
        _: 1
      }, 8, ["fields"])
    ]),
    _: 1
  }, 8, ["title"]))
}